import { Logger, NativeEventBridge } from "@ng-mw/shared-react-components"
import { userActions } from "@ng-mw/shared-react-components/user"
import { Store } from "redux"
import { showRegistrationPopup } from "@app/store/app/appActions"
import MenyNativeEvent from "@app/events/MenyNativeEvent"
import { RootState } from "@app/types"
import { getStringPropertyOrFallback } from "@app/helpers/getStringPropertyOrFallback"
import selectAppVersions from "@app/helpers/selectAppVersions"

export default async (store: Store<RootState, any>) => {
    interface OpenRegistrationPayload {
        phoneNumber?: string
        registrationType?: "trumf" | "corporate"
    }

    NativeEventBridge.listen(
        MenyNativeEvent.OpenRegistration,
        (payload?: OpenRegistrationPayload) => {
            // Close Trumf ID login drawer if it's open
            store.dispatch(userActions.hideTrumfIdLoginDrawer())
            // Open registration popup with payload from native
            store.dispatch(showRegistrationPopup(payload))
        },
        false,
    )

    // Unexpected exceptions from native wrapper (intoduced in NativeWrapper v63)
    NativeEventBridge.listen(
        "native-wrapper:log-exception",
        (payload: object) => {
            Logger.info("native.event.exception", {
                payload,
                ...selectAppVersions(store),
            })
        },
        false,
    )

    // Login events.

    NativeEventBridge.listen(
        MenyNativeEvent.Login,
        (payload: object) => {
            Logger.info("native.event.login.initiated", {
                correlationId: getStringPropertyOrFallback(payload, "correlationId", ""),
                ...selectAppVersions(store),
            })
        },
        false,
    )

    NativeEventBridge.listen(
        MenyNativeEvent.LoginCanceled,
        (payload: object) => {
            Logger.info("native.event.login.canceled", {
                correlationId: getStringPropertyOrFallback(payload, "correlationId", ""),
                ...selectAppVersions(store),
            })
        },
        false,
    )

    NativeEventBridge.listen(
        MenyNativeEvent.LoginComplete,
        (payload: object) => {
            Logger.info("native.event.login.complete", {
                correlationId: getStringPropertyOrFallback(payload, "correlationId", ""),
                ...selectAppVersions(store),
            })
        },
        false,
    )

    NativeEventBridge.listen(
        MenyNativeEvent.LoginFailed,
        (payload: object) => {
            Logger.error("native.event.login.failed", {
                correlationId: getStringPropertyOrFallback(payload, "correlationId", ""),
                error: getStringPropertyOrFallback(payload, "error", ""),
                ...selectAppVersions(store),
            })
        },
        false,
    )
}
